module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tab":{"all":"All","video":"Video Review"}}}')
  delete Component.options._Ctor
}
